module.exports = __webpack_public_path__ + "img/news4.a83e5f70.jpg";